export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-background/50 backdrop-blur-sm mt-auto">
      <div className="container mx-auto px-4 py-3 flex items-center justify-center text-xs text-muted-foreground">
        <div className="flex items-center gap-1">
          <span>© {currentYear} Kristian Nordhaug. Alle rettigheter reservert.</span>
          <span className="hidden sm:inline">
          </span>
        </div>
      </div>
    </footer>
  );
}
